import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'

export type Locale = 'de' | 'en'
export const STORAGE_KEY = 'infoscape-lang'

function detectInitialLocale(): Locale {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'de' || stored === 'en') return stored
  } catch {
    // localStorage might be unavailable
  }
  return 'en'
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  messages: { de, en },
  warnHtmlMessage: false,
  missingWarn: false,
  fallbackWarn: false,
})

export function setLocale(locale: Locale) {
  i18n.global.locale.value = locale
  document.documentElement.lang = locale
  document.title = i18n.global.t('meta.title')
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // ignore
  }
}
